<template>
  <multipane class="custom-resizer" layout="vertical">
    <div class="pane" style="width: 25%">
      <router-view></router-view>
    </div>
    <multipane-resizer></multipane-resizer>
    <div class="pane" :style="{ flexGrow: 1 }">
      <template v-if="params.id">
        <router-view name="a"></router-view>
      </template>
      <template v-else>
        <div class="index-box"></div>
      </template>
    </div>
  </multipane>
</template>

<script>
export default {
  computed: {
    params () {
      return this.$route.params
    }
  },
  methods: {
    getDocuments () {
      this.$store.dispatch('getDocuments')
    },

    getUsersSelect () {
      this.$store.dispatch('getUsersSelect')
    },

    getOffices () {
      this.$store.dispatch('getOffices')
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // vm.getDocuments()
      vm.getUsersSelect()
      vm.getOffices()
    })
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.multipane > div {
  z-index: auto;
}
.custom-resizer {
  width: 100%;
  height: calc(100vh - 100px);
}
.custom-resizer > .pane {
  text-align: left;
  /* padding: 15px; */
  overflow: hidden;
  /* background: #eee; */
  /* border: 1px solid #ccc; */
}
.custom-resizer > .pane ~ .pane {
}
.custom-resizer > .multipane-resizer {
  margin: 0; left: 0;
  position: relative;
  &:before {
    display: block;
    content: "";
    /* width: 3px; */
    width: 2px;
    height: 40px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -20px;
    /* margin-left: -1.5px; */
    margin-left: -2px;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
  }
  &:hover {
    &:before {
      border-color: #999;
    }
  }
}

.index-box {
  height: calc(100vh - 112px);
  overflow: scroll;
  margin-top: 10px;
  &:after {
    content: "\f040";
    font-family: FontAwesome;
    position: absolute;
    font-size: 250px;
    top: 50%;
    left: 50%;
    margin-top: -125px;
    margin-left: -125px;
    /* color: #ddd; */
    color: #aaa;
    opacity: 0.1;
    z-index: -1;
  }
}
</style>



// WEBPACK FOOTER //
// Documents.vue?7a0ef02b